














import { defineComponent } from '@vue/composition-api';

const ProgressRenderer = defineComponent({
  props: {
    progress: {
      default: () => ({
        success: 0,
        blue: 0,
        red: 0,
        gray: 0,
        yellow: 0,
      }),
    },
    done: { default: false },
  },
  // setup() {},
});

export default ProgressRenderer;
